
jQuery( document ).ready(function($) {

    AOS.init({
        duration: 800,
        easing: 'ease-in-out',
        once: true,
        delay: 0,
    });

    $(".mobile-icon .menu-icon").click(function(){
        $("body").toggleClass("menu-open");
    });

    let title = document.querySelectorAll(".header-nav-wrapper .navbar-nav .nav-item .plus-menu");

    title.forEach((qsitem) => {
      qsitem.addEventListener("click", function (e) {
        //   store the .answer div containing the answer
        let sibling = qsitem.nextElementSibling;
    
        // Nested loop for removing active class from all and set answer height to 0
        title.forEach((item) => {
          item.nextElementSibling.style.height = "0px";
          //   remove class "active" except for the currently clicked item
          item != qsitem && item.parentNode.classList.remove("active");
        });
        //then toggle the "active" class of clicked item's parent ".qna"
        this.parentNode.classList.toggle("active");
    
        // set actual height for .answer div if .qna has the class "active"
        if (qsitem.parentNode.classList.contains("active")) {
          sibling.style.height = sibling.scrollHeight + "px";
        } else {
          sibling.style.height = "0px";
        }
      });
    });

    let faq_title = document.querySelectorAll(".faq-wrapper .faq-item .faq-question");

    faq_title.forEach((qsitem) => {
      qsitem.addEventListener("click", function (e) {
        //   store the .answer div containing the answer
        let sibling = qsitem.nextElementSibling;
    
        // Nested loop for removing active class from all and set answer height to 0
        faq_title.forEach((item) => {
          item.nextElementSibling.style.height = "0px";
          //   remove class "active" except for the currently clicked item
          item != qsitem && item.parentNode.classList.remove("active");
        });
        //then toggle the "active" class of clicked item's parent ".qna"
        this.parentNode.classList.toggle("active");
    
        // set actual height for .answer div if .qna has the class "active"
        if (qsitem.parentNode.classList.contains("active")) {
          sibling.style.height = sibling.scrollHeight + "px";
        } else {
          sibling.style.height = "0px";
        }
      });
    });

    jQuery('.hero-slider .slider-wrapper').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
    });
    jQuery('.favourite-products .wrapper').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 990,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: true
                }
            },
            {
            breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true
                }
            }
        ]
    });
    jQuery('.fit-tea-slider .wrapper').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        adaptiveHeight: true
    });

    jQuery('.real-people-gallery').slick({
        infinite: true,
        slidesToShow: 9,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        speed: 6000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 7,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
            }
          }
        ]
    });

     $('.product-media-wrapper .product-media').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.product-media-wrapper .product-thumbnails'
    });
    $('.product-media-wrapper .product-thumbnails').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.product-media-wrapper .product-media',
        dots: false,
        arrows: true,
        centerMode: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
            }
          }
        ]
    });
    // $('.related-products .wrapper').slick({
    //   centerMode: true,
    //   //centerPadding: '0',
    //   slidesToShow: 3,
    //   slidesToScroll: 1,
    //   responsive: [
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         arrows: false,
    //         centerMode: true,
    //         centerPadding: '40px',
    //         slidesToShow: 3
    //       }
    //     },
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         arrows: false,
    //         centerMode: true,
    //         centerPadding: '40px',
    //         slidesToShow: 1
    //       }
    //     }
    //   ]
    // });
});